import type { ZendeskSettingsWebWidget, ZendeskWidget } from '../zendesk-widget';

interface IProps {
  apiKey: string;
  hideWidgetOnLoad?: boolean;
  widgetSettings?: ZendeskSettingsWebWidget;
}

let zenDeskWidgetLoaded = false;

const loadZendeskWidget = (settings: IProps): Promise<ZendeskWidget | undefined> => {
  if (window && !window.zE) {
    if (settings?.widgetSettings) {
      window.zESettings = {
        webWidget: settings.widgetSettings,
      };
    }

    const node = document.createElement('script');
    node.type = 'text/javascript';
    node.async = true;
    node.setAttribute('id', 'ze-snippet');
    node.setAttribute('src', `https://static.zdassets.com/ekr/snippet.js?key=${settings.apiKey}`);
    document.body.appendChild(node);
  }

  return new Promise((resolve, reject) => {
    const interval = setInterval(() => {
      if (window?.zE) {
        if (zenDeskWidgetLoaded !== true) {
          if (settings?.hideWidgetOnLoad) {
            window.zE?.('webWidget', 'hide');

            /**
             * When widget is closed, hide it again.
             */
            window.zE?.('webWidget:on', 'close', () => {
              window.zE?.('webWidget', 'hide');
            });

            window.zE?.('webWidget:on', 'open', () => {
              window.zE?.('webWidget', 'show');
            });
          }

          zenDeskWidgetLoaded = true;
        }

        resolve(window.zE);

        clearInterval(interval);
      }
    }, 500);

    setTimeout(() => {
      clearInterval(interval);

      if (!window.zE) {
        reject(null);
      }

      resolve(window.zE);
    }, 4000);
  });
};

export default loadZendeskWidget;
